// News
function populateReviews(newsData) {
   var title = newsData.title;
   var description = newsData.description;
   var image = newsData.image;
   var url = newsData.url;
   var content = "";

   for (var i = 0; i < newsData.length; i++) {
       content +=
        '<div class="col-12">'+
           '<div class="review-card">'+
             '<div class="review-title">'+
              newsData[i].title+
             '</div>'+
             '<div class="review-body">'+
              newsData[i].description+
             '</div>';
       if(newsData[i].url && newsData[i].urlText) {
          content +=
             '<div class="review-body"><a href="'+newsData[i].url+'" target="_blank">'+newsData[i].urlText+'</a></div>';
       }
       content +=
           '</div>'+
        '</div>';
   }

   document.getElementById("newsContainer").innerHTML = content;
}

populateReviews(newsData);
